import WIDGET_VERSION from './widgetVersions.js';

export const STEP_NAMES = {
    VEHICLE_INFO: 'VEHICLE_INFO',
    VEHICLE_OPTIONS: 'VEHICLE_OPTIONS',
    CONTACT_INFORMATION: 'CONTACT_INFORMATION',
    CBB_ESTIMATE: 'CBB_ESTIMATE',
    APPOINTMENT_FORM: 'APPOINTMENT_FORM',
    VEHICLE_CONDITION: 'VEHICLE_CONDITION',
    VEHICLE_APPRAISAL: 'VEHICLE_APPRAISAL',
    ERROR_INSPECTION: 'ERROR_INSPECTION',
    OFFICIAL_EVALUATION: 'OFFICIAL_EVALUATION',
};

export const STEP_HEADER_VISIBILITY = {
    [STEP_NAMES.VEHICLE_INFO]: true,
    [STEP_NAMES.VEHICLE_OPTIONS]: true,
    [STEP_NAMES.CONTACT_INFORMATION]: true,
    [STEP_NAMES.CBB_ESTIMATE]: true,
    [STEP_NAMES.APPOINTMENT_FORM]: false,
    [STEP_NAMES.VEHICLE_CONDITION]: true,
    [STEP_NAMES.VEHICLE_APPRAISAL]: false,
    [STEP_NAMES.ERROR_INSPECTION]: false,
    [STEP_NAMES.OFFICIAL_EVALUATION]: false,
};

export default {
    [WIDGET_VERSION.TRADE_360]: [
        { i18n_key: 'TRADE_IN.SECTIONS.VEHICLE_INFO', iconClass: 'icon-cbb-icons-vehicle-information' },
        { i18n_key: 'TRADE_IN.SECTIONS.CONTACT_INFO', iconClass: 'icon-cbb-icons-contact' },
    ],
    [WIDGET_VERSION.DILAWRI]: [
        { i18n_key: 'TRADE_IN.SECTIONS.VEHICLE_INFO', iconClass: 'icon-cbb-icons-vehicle-information' },
        { i18n_key: 'TRADE_IN.SECTIONS.VEHICLE_OPTIONS', iconClass: 'icon-cbb-icons-vehicle-options' },
        { i18n_key: 'TRADE_IN.SECTIONS.VEHICLE_CONDITION', iconClass: 'icon-cbb-icons-vehicle-condition' },
        { i18n_key: 'TRADE_IN.SECTIONS.CONTACT_INFO', iconClass: 'icon-cbb-icons-contact' },
    ],
};
